import api from './api';

const REMEMBER_KEY = 'fmz_remember';

/** Which storage is active — localStorage if remembered, sessionStorage otherwise. */
function storage() {
  return localStorage.getItem(REMEMBER_KEY) === '1' ? localStorage : sessionStorage;
}

export async function login(username, password, remember = false) {
  const { data } = await api.post('/login', { username, password });

  // Persist the remember preference first so storage() picks the right one
  if (remember) {
    localStorage.setItem(REMEMBER_KEY, '1');
  } else {
    localStorage.removeItem(REMEMBER_KEY);
  }

  storage().setItem('token', data.token);
  storage().setItem('user', JSON.stringify(data.user));
  return data.user;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');
  localStorage.removeItem(REMEMBER_KEY);
}

export function getToken() {
  return localStorage.getItem('token') || sessionStorage.getItem('token') || null;
}

export function getUser() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function isLoggedIn() {
  return !!getToken();
}

function truthyFlag(v) {
  return v === true || v === 1 || v === '1';
}

export function isAdmin() {
  return truthyFlag(getUser()?.isadmin);
}

export function isAccount() {
  return truthyFlag(getUser()?.isaccount);
}

export function isFinance() {
  return isAdmin() || isAccount();
}
